import { CONNECT_INFO, WHATSAPP_LINKS } from '../constants/connect';
import './SiteFooter.css';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="foot-container">
        <div className="foot-col">
          <div className="foot-brand">{CONNECT_INFO.brand}</div>
          <p className="foot-meta">CNPJ: {CONNECT_INFO.cnpj}</p>
          <p className="foot-meta">Endereco: {CONNECT_INFO.address}</p>
          <a
            className="foot-primary-cta"
            href={WHATSAPP_LINKS.estoque}
            target="_blank"
            rel="noreferrer"
          >
            Agendar visita
          </a>
        </div>

        <div className="foot-col">
          <div className="foot-title">Contato</div>
          <ul className="foot-list">
            <li>
              WhatsApp:{' '}
              <a href={WHATSAPP_LINKS.estoque} target="_blank" rel="noreferrer">
                {CONNECT_INFO.whatsappE164}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="foot-legal">(c) {year} {CONNECT_INFO.brand}. Todos os direitos reservados.</div>
    </footer>
  );
}
